'use client';
import { db } from '@/firebase/client';
import { UserChat } from '@/lib/chat/init';
import { doc, onSnapshot } from 'firebase/firestore';

// チャット数と内容を取る
export async function watchChat(
  uid: string,
  onChange: (v: UserChat[]) => void,
) {
  return onSnapshot(doc(db, 'userChats', uid), (docSnap) => {
    if (docSnap.data()) {
      const newUserChats: UserChat[] = Object.entries(
        docSnap.data() as { [id: string]: UserChat },
      ).map((a) => a[1]);
      onChange(newUserChats);
    } else {
      onChange([]);
    }
  });
}
